/** Per-tenant WStudio derived-config client (WSRPDM-0024). */
import { request } from '../client';

export interface WStudioField {
  key: string;
  kind: 'tenant' | 'value' | 'param' | 'url' | 'map';
  value?: string | null;
  set?: boolean;
  derived?: string;
  overridden?: boolean;
  isSecret?: boolean;
  valueSet?: boolean;
  valueSuffix?: string | null;
}

export type ContactFieldScope = 'GLOBAL' | 'TENANT';

export type ContactFieldStatus =
  | 'RESOLVED_FROM_FIELD_KEY'
  | 'RESOLVED_FROM_FIELD_ID'
  | 'UNRESOLVED_NOT_FOUND_IN_GHL'
  | 'UNRESOLVED_UNKNOWN_ATTRIBUTE'
  | 'UNSUPPORTED_CORE_FIELD_MAPPING';

export interface WStudioContactField {
  key: string;
  attributeId: string | null;
  attributeLabel: string | null;
  source: 'USER_ATTRIBUTE' | 'SALES_LOOKUP';
  scope: ContactFieldScope;
  required: boolean;
  fieldKey: string | null;
  resolvedFieldId: string | null;
  status: ContactFieldStatus;
}

export interface WStudioTenantConfig {
  fields: WStudioField[];
  contactMappings: Record<string, string>;
  contactFields?: WStudioContactField[];
}

export interface WStudioTenantUpdate {
  domain: string;
  token?: string;
  studioId?: string;
  reportCheckinUserId?: string;
  overrides?: Array<{ key: string; value: string }>;
  clearOverrides?: string[];
  contactMappings?: Record<string, string>;
  contactFieldMappings?: Array<{ attributeId: string; fieldKey?: string }>;
}

const tenantConfigPath = (slug: string) => `/admin/platform/tenants/${slug}/wstudio-config`;

export async function getTenantConfig(slug: string): Promise<WStudioTenantConfig> {
  return request<WStudioTenantConfig>('GET', tenantConfigPath(slug));
}

export async function putTenantConfig(
  slug: string,
  body: WStudioTenantUpdate,
): Promise<WStudioTenantConfig> {
  return request<WStudioTenantConfig>('PUT', tenantConfigPath(slug), { json: body });
}
